import { Button, Heading, Input, Text, useMatchBreakpoints } from '@pancakeswap/uikit'
import React from 'react'
import styled from 'styled-components'
import { Tooltip } from 'react-tooltip'
import truncateHash from '@pancakeswap/utils/truncateHash'

const ReferralPage = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  justify-content: flex-start;
  gap: 48px;
  width: 78%;
  @media screen and (max-width: 1440px) {
    padding 0px 16px;
  width: 100%;

  }
  @media screen and (max-width: 900px) {
    padding 0px 16px;
  width: 100%;

  }
  @media screen and (max-width: 575px) {
    padding 0px 16px;
  width: 100%;

  }
`
const StyledHead = styled(Heading)`
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: 56px; /* 125% */
  letter-spacing: -0.96px;
  background: var(--primary-primary-gradient-2, linear-gradient(180deg, #7b3fe4 0%, #a726c1 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media screen and (max-width: 575px) {
    font-size: 24px;
    line-height: 32px;
  }
`
const StyledSubtitle = styled(Text)`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 24px;
  color: rgba(173, 171, 178, 1);
  @media screen and (max-width: 575px) {
    font-size: 16px;
    margin-top: 16px;
    line-height: 24px;
  }
  .title {
    color: white;
    font-weight: 700;
  }
`
const CardRegister = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 30px;
  width: 100%;
  height: auto;
  padding: 40px;
  border-radius: 16px;
  background: var(--greyscale-grayscale-3, #141217);
  box-shadow: 0px 64px 64px -48px rgba(15, 15, 15, 0.1);
  position: relative;
  .upto {
    position: absolute;
    top: -12%;
    right: -7%;
  }
  @media screen and (max-width: 575px) {
    padding: 40px 16px;
    .upto {
      position: relative;
      top: 0;
      right: 0;
      width: 343px;
    }
  }
`
const GroupLinkRef = styled.div`
  flex-direction: column;
  display: flex;
  gap: 48px;
  width: 100%;
`
const StyledText = styled(Text)`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: rgba(173, 171, 178, 1);
`
const WrapperLinkRef = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;
  border-radius: 16px;
  border: 1px solid var(--white-white-8, rgba(255, 255, 255, 0.08));
  background: var(--black-black-5, rgba(0, 0, 0, 0.05));
  padding: 32px;
  gap: 32px;
  @media screen and (max-width: 575px) {
    padding: 16px;
    width: 100%;
  }
`

const GroupLink = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  @media screen and (max-width: 575px) {
    flex-direction: column;
  }
`
const StyledLink = styled.div`
  width: 100%;
  border-radius: 12px;
  background: var(--greyscale-grayscale-4, #2d2c33);
  border: none;
  outline: none;
  color: black;
  font-size: 18px;
  flex-direction: row-reverse;
  min-height: 34px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 20px;
  padding: 12px 16px;

  ${({ theme }) => theme.mediaQueries.md} {
    min-height: 44px;
  }
`
const LinkItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  width: 100%;
`
const ShowLinkRefPc = styled.span`
  display: none;
  word-break: break-all;
  color: #fff;
  ${({ theme }) => theme.mediaQueries.sm} {
    display: block;
  }
`
const ShowLinkRefMobile = styled.span`
  display: block;
  word-break: break-all;
  color: #fff;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: none;
  }
`
const StyledIconRef = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`
const StyledInput = styled(Input)`
  outline: none;
  border-radius: 12px;
  background: var(--greyscale-grayscale-4, #2d2c33);
  padding: 12px 16px;
  height: 44px;
  &:focus:not(:disabled) {
    border: none;
  }
`
const StyledButton = styled(Button)`
  background: rgb(217, 217, 217);
  font-weight: 500;
  color: rgb(98, 22, 176);
  margin-top: 30px;
  font-size: 16px;
  line-height: 20px;
  border-radius: 90px;
  width: 192px;
  border: 2px solid var(--greyscale-grey-scale-text-seconday, #adabb2);
  @media screen and (max-width: 575px) {
    margin-top: 0px;
  }
`
const GroupSearchByCode = styled.div`
  .search {
    position: absolute;
    top: 20%;
    width: 24px;
    height: 24px;
    right: 2%;
    cursor: pointer;
  }
`
const StyledHeadSearchUser = styled(Heading)`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 12px;
`
const StyledInputSearch = styled(Input)`
  outline: none;
  height: 48px;
  border-radius: 12px;
  background: var(--greyscale-grayscale-4, #2d2c33);
  padding: 12px 16px;

  &:focus:not(:disabled) {
    border: none;
  }
  ::placeholder {
    color: #67666e;
  }
`
const ButtonLink = styled.button`
  width: 192px;
  border-radius: 90px;
  border: 2px solid var(--greyscale-grey-scale-text-seconday, #adabb2);
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 1);
  background: rgba(20, 18, 23, 1);
  cursor: pointer;
`
const Step = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`
const TitleStep = styled(Text)`
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  color: rgba(255, 255, 255, 1);
`
const LabelStep = styled(Text)`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: rgba(173, 171, 178, 1);
`
const CardStep = styled.div`
  display: flex;
  margin-top: 24px;
  gap: 24px;
  justify-content: space-between;

  @media screen and (max-width: 575px) {
    flex-direction: column;
    align-items: center;
  }
`
const Card = styled.div`
  width: 340px;
  border-radius: 8px;
  background: var(--white-white-6, rgba(255, 255, 255, 0.06));
  padding: 29px 25px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  .imgStep {
    width: 48px;
    height: 48px;
  }
  @media screen and (max-width: 1440px) {
    width: 100%;
  }
`
const CardTitle = styled(Text)`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: rgba(255, 255, 255, 1);
`
const PageReferral = ({
  linkRef,
  handleRef,
  handleLeave,
  userIsRegister,
  showCopied,
  referCode,
  validateReferByWallet,
  showError,
  onRegister,
  userSearch,
  setUserSearch,
  handleSearchUserCode,
  showResultSearch,
  setTab,
}) => {
  const { isMobile } = useMatchBreakpoints()
  const formatLinkRef = (ref, start, end) => {
    if (ref?.includes('0x')) {
      return truncateHash(ref, start, end)
    }
    return linkRef
  }
  return (
    <ReferralPage>
      <div>
        <StyledHead>Referral Program</StyledHead>
        <StyledSubtitle>
          Multiply gains, your Referrals defend. Refer Friends to Earn Massive Rewards Together.
        </StyledSubtitle>
        <img style={{ display: isMobile ? 'flex' : 'none' }} className="upto" src="/images/V3/upto.svg" />
      </div>
      <CardRegister>
        <img style={{ display: isMobile ? 'none' : 'flex' }} className="upto" src="/images/V3/upto.svg" />
        <GroupLinkRef>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <StyledText style={{ fontWeight: '700', color: 'white', fontSize: '28px' }}>
              Referral Registration
            </StyledText>
          </div>
          <WrapperLinkRef>
            <Text
              fontSize={['16px', '16px', '18px', '24px', '24px']}
              fontWeight="600"
              lineHeight="32px"
              style={{ color: 'rgba(255, 255, 255, 1)' }}
            >
              {' '}
              Earn up to 10%
            </Text>
            <GroupLink>
              <div style={{ width: isMobile ? '100%' : '50%' }}>
                <StyledText
                  style={{ color: 'rgba(255, 255, 255, 1)', marginBottom: '12px' }}
                  color="rgba(255, 255, 255, 1)"
                >
                  Referral link
                </StyledText>
                <StyledLink>
                  <LinkItem>
                    <ShowLinkRefPc>{formatLinkRef(linkRef, 50, 4)}</ShowLinkRefPc>
                    <ShowLinkRefMobile>{formatLinkRef(linkRef, 20, 4)}</ShowLinkRefMobile>
                    <StyledIconRef
                      id="iconRef"
                      src="/images/referral/copy.svg"
                      onClick={handleRef}
                      onMouseLeave={handleLeave}
                    />
                    <Tooltip
                      anchorId="iconRef"
                      content={userIsRegister ? (showCopied ? 'Copied' : 'Copy') : 'Please Register'}
                    />
                  </LinkItem>
                </StyledLink>
              </div>
              {!userIsRegister && (
                <>
                  <div style={{ width: isMobile ? '100%' : '50%' }}>
                    <StyledText
                      style={{ color: 'rgba(255, 255, 255, 1)', marginBottom: '12px' }}
                      color="rgba(255, 255, 255, 1)"
                    >
                      Referral code
                    </StyledText>
                    <StyledInput
                      value={referCode}
                      autoFocus={true}
                      onChange={validateReferByWallet}
                      placeholder={`refer code`}
                    />
                    {showError && referCode && <span style={{ color: 'red' }}>Invalid code</span>}
                  </div>
                  <StyledButton onClick={onRegister} disabled={userIsRegister || showError}>
                    Register
                  </StyledButton>
                </>
              )}
            </GroupLink>
            <div style={{ display: 'flex', gap: '32px', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ width: '100px', height: '1px', background: 'rgba(255, 255, 255, 0.10)' }}></div>
              <Text fontSize="18px" fontWeight="500" lineHeight="20px">
                Or
              </Text>
              <div style={{ width: '100px', height: '1px', background: 'rgba(255, 255, 255, 0.10)' }}></div>
            </div>
            <GroupSearchByCode>
              <StyledHeadSearchUser>Search By Code</StyledHeadSearchUser>
              <div style={{ position: 'relative' }}>
                <StyledInputSearch
                  value={userSearch}
                  autoFocus={true}
                  onChange={(e) => setUserSearch(e.target.value)}
                  placeholder={`Enter code`}
                />
                <div onClick={handleSearchUserCode}>
                  <img className="search" src="/images/V3/search.png" />
                </div>
              </div>
              {showResultSearch()}
            </GroupSearchByCode>
          </WrapperLinkRef>
        </GroupLinkRef>
        <ButtonLink onClick={() => setTab(3)}>Check my refer list</ButtonLink>
      </CardRegister>
      <Step>
        <TitleStep>Getting Started:</TitleStep>
        <LabelStep>To activate up to 1,000 USDT trading fee rebate voucher:</LabelStep>
        <CardStep>
          <Card>
            <img className="imgStep" src="/images/V3/Step1.png" />
            <CardTitle>Step 1</CardTitle>
            <LabelStep>Grab your referral link or code.</LabelStep>
          </Card>
          <Card>
            <img className="imgStep" src="/images/V3/Step2.png" />
            <CardTitle>Step 2</CardTitle>
            <LabelStep>
              Invite friends to sign up with your ref link or code and deposit more than $100 within 14 days of
              registration.
            </LabelStep>
          </Card>
          <Card>
            <img className="imgStep" src="/images/V3/Step3.png" />
            <CardTitle>Step 3</CardTitle>
            <LabelStep>You and your friend will both receive equal vouchers that rebate the trading fee.</LabelStep>
          </Card>
        </CardStep>
      </Step>
    </ReferralPage>
  )
}
export default PageReferral
